import styled from 'styled-components'

const Image = styled.a`
    width: 60%;
    height: 500px;
    overflow-y: hidden;
`

export default Image